export const customContentTypeFragment = `
    key
    slug
    name
    localName
    namePlural
    localNamePlural
    titleHelpText
    localTitleHelpText
    contentHelpText
    localContentHelpText
    detailViewTemplateIds
    listViewTemplateIds
    hasFeaturedImage
    hasSchedulePublishArchiveDelete
    hasRevisions
    hasExtraFields
    translations {
        language
        values {
            key
            value
        }
    }
    formFields {
        guid
        title
        description
        isMandatory
        fieldType
        fieldOptions
    }
`
